<template>
  <div>
    <div>
      <v-btn text color="primary" class="mt-6" @click="openArchiveDialog()" :disabled="isDisabaled()">
        <v-icon>save_alt</v-icon>{{ $tt('customExport') }}
      </v-btn>
    </div>

    <!-- エクスポートダイアログ -->
    <v-dialog v-model="showArchiveDialog" persistent max-width="600">
      <v-card v-if="isArchiveSelectFormat()" class="export-dialog-card">
        <v-card-title v-if="isRefLinesExportMode()">
          <v-icon>save_alt</v-icon>
          {{ $tt('customExportRefLine') }}
        </v-card-title>
        <v-card-title v-if="isTasksExportMode()">
          <v-icon>save_alt</v-icon>
          {{ $tt('customTaskExport') }}
        </v-card-title>
        <div class="export-type-select">
          <v-row>
            <v-col cols="6">
              <v-card class="selected-export-type" elevation="1">
                <v-card-title class="grey lighten-3">
                  <h5 class="grey lighten-3 grey--text text--darken-1">
                    <img src="/images/aid-16.png" />
                    AgriBus TSV
                  </h5>
                </v-card-title>
                <v-card-text class="select-export-type-text">{{ $tt('customTaskWhatIsAgriBusFormat') }}</v-card-text>
                <v-card-actions class="grey lighten-3">
                  <v-btn outlined block color="red">{{ $tt('customSelected') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="1">
                <v-card-title class="grey lighten-3">
                  <h5 class="grey lighten-3 grey--text text--darken-1">{{ $tt('customTaskNowDeveloping') }}</h5>
                </v-card-title>
                <v-card-text class="select-export-type-text">
                  {{ $tt('customTaskNowDevelopingDescription') }}
                </v-card-text>
                <v-card-actions class="grey lighten-3">
                  <v-btn outlined block color="grey">{{ $tt('customNotAvailable') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="secondary" class="white--text text-none" @click="closeArchiveDialog()">
            {{ $tt('customCancel') }}
          </v-btn>
          <v-btn v-if="hasFreeFunctionality()" class="text-none" disabled>
            <v-icon>play_arrow</v-icon>
            {{ $tt('customTaskStartExporting') }}
          </v-btn>
          <v-btn v-if="!hasFreeFunctionality()" color="warning" class="text-none" @click="startArchiving()">
            <v-icon>play_arrow</v-icon>
            {{ $tt('customTaskStartExporting') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- ダウンロードインジケータ -->
      <v-card v-if="isArchiveDownloading()" class="export-dialog-card">
        <v-card-title>{{ $tt('customTaskNowExporting') }}</v-card-title>
        <v-card-text>{{ archivingMessage }}</v-card-text>
        <v-card-text>
          <v-progress-linear :value="archiveExecutionPercentage" height="25" reactive>
            <strong>{{ Math.ceil(archiveExecutionPercentage) }}%</strong>
          </v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="grey darken-1" class="white--text text-none" @click="closeArchiveDialog()">
            {{ $tt('customCancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- ダウンロード完了 -->
      <v-card v-if="isArchiveFinished()" class="export-dialog-card">
        <v-card-title>{{ $tt('customTaskDownloadReady') }}</v-card-title>
        <v-card-actions>
          <v-btn color="warning" class="text-none" @click="downloadArchive()" block>
            <v-icon small>save_alt</v-icon>
            {{ $tt('customDownload') }}( {{ archiveFileSize }} )
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TaskFilterMixin from '@/components/mixins/task-filter-mixin'
import connectHttpBase from '@/lib/connect-client/connect-http-base'
import connectNaviClient from '@/lib/connect-client/connect-navi-client'
import connectDatastoreClient from '@/lib/connect-client/connect-datastore-client'
import * as Constants from '@/lib/constants'
import Toast from '@/lib/toast'
import UserInfo from '@/lib/user-info'
import FileSaver from 'file-saver'

const convert = require('convert-units')

export default {
  name: 'ExportDialog',
  mixins: [TaskFilterMixin],
  props: {
    exportMode: {
      required: true,
      type: Number,
    },
    selectFilter: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      // Export
      showArchiveDialog: false,
      archiveDialogStep: Constants.TASK_ARCHIVE_DIALOG_STEP_SELECT_FORMAT,
      archiveExecutionPercentage: 0,
      archivingMessage: '',
      archiveProgressBarStriped: true,
      archiveProgressBarAnimated: true,
      archiveProgressBarVariant: 'secondary',
      archiveFileSize: undefined,
      archiveDownloadUrl: undefined,
      pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
      pageNumber: 1,

      filterName: null,
    }
  },
  computed: {
    refLines() {
      return this.$store.getters.refLines
    },
    tasks() {
      return this.$store.getters.tasks
    },
  },
  methods: {
    isDisabaled() {
      if (this.isRefLinesExportMode()) {
        return this.refLines.length === 0
      }
      if (this.isTasksExportMode()) {
        return this.tasks.length === 0
      }
      return true
    },
    isRefLinesExportMode() {
      return this.exportMode === Constants.EXPORT_MODE.REFLINES
    },
    isTasksExportMode() {
      return this.exportMode === Constants.EXPORT_MODE.TASK_RECORDS
    },
    toBilling() {
      this.$router.push({ name: 'BillingBilling' })
    },

    sseUrl() {
      const pageIndex = this.pageNumber - 1
      if (this.isRefLinesExportMode()) {
        if (UserInfo.isFSMigrated()) {
          return connectDatastoreClient.getRefLinesTsvArchiveEndpoint(pageIndex, this.pageSize)
        } else {
          return connectNaviClient.getRefLinesTsvArchiveEndpoint(pageIndex, this.pageSize)
        }
      }
      if (this.isTasksExportMode()) {
        if (UserInfo.isFSMigrated()) {
          return connectDatastoreClient.getTsvArchiveEndpoint(this.filterName, pageIndex, this.pageSize)
        } else {
          return connectNaviClient.getTsvArchiveEndpoint(this.filterName, pageIndex, this.pageSize)
        }
      }
    },
    //--------------------
    // Export
    //--------------------
    downloadArchive() {
      FileSaver.saveAs(this.archiveDownloadUrl, 'tasks.zip')
      this.closeArchiveDialog()
    },
    archive(functionHolder) {
      const url = this.sseUrl()
      const authHeader = connectHttpBase.getHttpAuthHeader()
      const headers = Object.assign({}, authHeader)
      // eslint-disable-next-line no-undef
      let eventSource = new EventSourcePolyfill(url, {
        headers: headers,
      })
      eventSource.onerror = function(e) {
        console.error(e)
        Toast.error(e.message)
        eventSource.close()
        functionHolder.closeWindow()
      }
      let exportSize = 0
      let count = 0
      eventSource.addEventListener('size', event => {
        this.unsetProgressBarAnimated('primary')
        this.archiveExecutionPercentage = 0
        exportSize = Number(event.data)
      })
      eventSource.addEventListener('archive', event => {
        ++count
        this.archiveExecutionPercentage = (count / exportSize) * 100
        let currentId = null
        if (UserInfo.isFSMigrated()) {
          currentId = event.data
        } else {
          currentId = JSON.parse(event.data)
        }
        this.archivingMessage = 'Archiving... ' + currentId
      })
      eventSource.addEventListener('archived', event => {
        this.archiveExecutionPercentage = 100
        this.archivingMessage = 'Finishing...'
        this.setProgressBarAnimated('secondary')
      })
      eventSource.addEventListener('filesize', event => {
        const fileSize = Number(event.data)
        const convertedFileSize = convert(fileSize)
          .from('b')
          .toBest()
        if (convertedFileSize) {
          this.archiveFileSize = Math.round(convertedFileSize.val) + convertedFileSize.unit
        }
      })
      eventSource.addEventListener('finished', event => {
        this.archiveDownloadUrl = null
        if (UserInfo.isFSMigrated()) {
          this.archiveDownloadUrl = event.data
        } else {
          this.archiveDownloadUrl = JSON.parse(event.data)
        }
        this.archiveDialogStep = Constants.TASK_ARCHIVE_DIALOG_STEP_FINISHED
        eventSource.close()
      })
    },
    startArchiving() {
      if (this.isRefLinesExportMode()) {
        this.pageSize = this.$store.getters.pagingOptions.refLines.pageSize
        this.pageNumber = this.$store.getters.pagingOptions.refLines.page + 1
      }

      if (this.isTasksExportMode()) {
        this.pageSize = this.$store.getters.pagingOptions.tasks.pageSize
        this.pageNumber = this.$store.getters.pagingOptions.tasks.page + 1
      }

      this.archiveDialogStep = Constants.TASK_ARCHIVE_DIALOG_STEP_DOWNLOADING
      this.archivingMessage = 'Preparing...'
      this.setProgressBarAnimated('secondary')

      const functionHolder = { closeWindow: this.closeArchiveDialog }

      if (this.isRefLinesExportMode()) {
        this.archive(functionHolder)
      }
      if (this.isTasksExportMode()) {
        this.setDataFromSelectFilter(this.selectFilter)
        const taskFilter = this.buildTaskFilter()

        if (UserInfo.isFSMigrated()) {
          connectDatastoreClient
            .saveTaskFilter(taskFilter)
            .then(response => {
              this.filterName = response.data.filterName
// TEMP               console.log(this.filterName)
              this.archive(functionHolder)
            })
            .catch(error => {
              console.error(error)
              Toast.error(error)
            })
        } else {
          connectNaviClient
            .saveTaskFilter(taskFilter)
            .then(response => {
              this.filterName = response.data.filterName
              this.archive(functionHolder)
            })
            .catch(error => {
              console.error(error)
              Toast.error(error)
            })
        }
      }
    },
    /** アニメーションはvalueに値が入っている場合のみです */
    setProgressBarAnimated(variant) {
      this.archiveProgressBarStriped = true
      this.archiveProgressBarAnimated = true
      this.archiveProgressBarVariant = variant
    },
    unsetProgressBarAnimated(variant) {
      this.archiveProgressBarStriped = false
      this.archiveProgressBarAnimated = false
      this.archiveProgressBarVariant = variant
    },
    isArchiveSelectFormat() {
      return this.archiveDialogStep === Constants.TASK_ARCHIVE_DIALOG_STEP_SELECT_FORMAT
    },
    isArchiveDownloading() {
      return this.archiveDialogStep === Constants.TASK_ARCHIVE_DIALOG_STEP_DOWNLOADING
    },
    isArchiveFinished() {
      return this.archiveDialogStep === Constants.TASK_ARCHIVE_DIALOG_STEP_FINISHED
    },
    openArchiveDialog() {
      this.showArchiveDialog = true
      this.archiveDialogStep = Constants.TASK_ARCHIVE_DIALOG_STEP_SELECT_FORMAT
      this.archiveExecutionPercentage = 0
      this.archivingMessage = ''
      this.setProgressBarAnimated('secondary')
    },
    closeArchiveDialog() {
      this.showArchiveDialog = false
      this.archiveDialogStep = Constants.TASK_ARCHIVE_DIALOG_STEP_SELECT_FORMAT
    },
    hasFreeFunctionality() {
      return UserInfo.hasFreeFunctionality()
    },
  },
}
</script>

<style scoped>
.export-type-select {
  margin: 10px;
}

.grey-text {
  color: grey;
}

.select-export-type-text {
  margin-top: 10px;
}

.selected-export-type {
  border: solid;
  border-width: 1px;
  border-color: red;
}

.free-plan-alert {
  margin: 20px;
}

.export-dialog-card {
  padding: 5px 5px 5px 5px;
}
.theme--light.v-messages {
  display: none !important;
}
</style>
